import { render, staticRenderFns } from "./GraficoEstadosPorcentajeProperties.vue?vue&type=template&id=2320aba6&scoped=true"
import script from "./GraficoEstadosPorcentajeProperties.vue?vue&type=script&lang=js"
export * from "./GraficoEstadosPorcentajeProperties.vue?vue&type=script&lang=js"
import style0 from "./GraficoEstadosPorcentajeProperties.vue?vue&type=style&index=0&id=2320aba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2320aba6",
  null
  
)

export default component.exports